import { createContext, ElementType } from 'react'

export default createContext<{ linkComponent: ElementType }>({ linkComponent: 'a' })
